import fetch from '../fetch';

import {
  USER_INFO_OLD,
  USER_LEVEL,
  USER_GIFT,
  USER_GROWTH_DETAIL,
  USER_INTEGRAL_INFO,
  USER_INTEGRAL_DETAIL,
  USER_ACTION_LIST,
  USER_ACTION_LIST_COLMO,
  USER_OPERATE_LOG,
  USER_PLATFORM,
  USER_TAGS,
  USER_ADDRESS_LIST,
  GROWTH_UP_API_GET_OFFLINE_ORDER
} from '../url';

// 查询会员信息详情
function getUserInfo(data) {
  return fetch({
    url: USER_INFO_OLD,
    method: 'get',
    params: data,
    isNoMsg: true
  });
}

// 查询会员等级
function getUserLevel(data) {
  return fetch({
    url: USER_LEVEL,
    method: 'post',
    data: data
  });
}

// 查询会员权益
function getUserGift(data) {
  return fetch({
    url: USER_GIFT,
    method: 'get',
    params: data,
    isNoMsg: true
  });
}

// 查询成长值明细
function getGrowthList(data) {
  return fetch({
    url: USER_GROWTH_DETAIL,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询积分明细
function getIntegralInfo(data) {
  return fetch({
    url: USER_INTEGRAL_INFO,
    method: 'get',
    params: data,
    isNoMsg: true
  });
}

// 查询积分明细
function getIntegralList(data) {
  return fetch({
    url: USER_INTEGRAL_DETAIL,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询会员行为信息
function getUserActionList(data) {
  return fetch({
    url: USER_ACTION_LIST,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询会员行为信息
function getUserActionListColmo(data) {
  return fetch({
    url: USER_ACTION_LIST_COLMO,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询操作日志
function getOperateLog(data) {
  return fetch({
    url: USER_OPERATE_LOG,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询会员平台
function getUserPaltform(data) {
  return fetch({
    url: USER_PLATFORM,
    method: 'get',
    params: data,
    isNoMsg: true
  });
}

// 查询会员标签
function getUserTags(data) {
  return fetch({
    url: USER_TAGS,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 查询地址信息
function getUserAddressList(data) {
  return fetch({
    url: USER_ADDRESS_LIST,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

// 美的品牌 —— 消费信息
function getOfflineOrder(data) {
  return fetch({
    url: GROWTH_UP_API_GET_OFFLINE_ORDER,
    method: 'post',
    data: data,
    isNoMsg: true
  });
}

const memberDetail = {
  getUserInfo,
  getUserLevel,
  getUserGift,
  getGrowthList,
  getIntegralInfo,
  getIntegralList,
  getUserActionList,
  getUserActionListColmo,
  getOperateLog,
  getUserPaltform,
  getUserTags,
  getUserAddressList,
  getOfflineOrder,
};

export { memberDetail };
